import React from 'react';
import PropTypes from 'prop-types';

export function ButtonDefault(props) {
    const extraClass = props.className;

    return (
        <button {...props} type="button" className={`odf-btn odf-btn-sm odf-btn-secondary ${extraClass}`}>
            {props.children}
        </button>
    );
}

ButtonDefault.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

ButtonDefault.defaultProps = {
    className: '',
};
